<template>
  <div class="search-div">
    <form action="/">
      <van-search
        v-model="value"
        show-action
        placeholder="请输入搜索关键词"
        ref="autofocus"
        @search="onSearch"
        @cancel="onCancel"
      />
    </form>
      
      <div class="info-list-bottom">
        <div>
          <ul class="info-dataList">
            <div>搜索结果</div>
            <li
              v-for="(item,index) in productList"
              :key="index"
              class="li-style2"
              @click="chooseLi2(item,index)"
            >
              {{item.name}}
              <span
                :class="isLinkBot==index ? 'li-style2 li-check-style2' : 'li-style2'"
              >{{item.value.length}}</span>
              <svg-icon v-if="isLinkBot==index" icon-class="home_line2"></svg-icon>
            </li>
          </ul>
          <div class="info-list-list" v-for="(item,index) in productList" :key="index+'1'">
            <div v-if="item.name=='保险' && leave==item.name">
              <div class="bank-list" @click.prevent="checkData(ctem)" v-for="(ctem, index) in item.value" :key="index">
                <div class="list-com bank-top">
                  <div class="bank-top-left">
                    <div class="bank-left-img">
                      <img :src="ctem.thumbnail" alt />
                    </div>
                    <div>
                      <p class="product-list-title">{{ctem.name}}</p>
                      <p class="product-list-summary">手续简单抵押率高</p>
                    </div>
                  </div>
                </div>
                <div class="list-com bank-bottom">
                  <p v-html="ctem.digest"></p>
                </div>
              </div>
            </div>
            <div v-if="item.name!='保险' && leave==item.name">
              <div class="bank-list product-safe" @click.prevent="checkData(ctem)" v-for="(ctem, index) in item.value" :key="index">
                <div class="product-safe-left">
                  <img :src="ctem.thumbnail" alt />
                </div>
                <div class="product-safe-right">
                  <div>
                    <p class="product-list-title">{{ctem.name}}</p>
                    <div class="safe-right-height">
                      <p v-html="ctem.digest" class="product-list-summary"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hint-div" v-if="isShow">未搜索到相关产品</div>
      </div>
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant'
import { setLocal } from "@/utils/utils";
import URL from '@/api/api'
export default {
  data() {
    return {
      value: '',
      isLinkBot: '0',
      productList:[],
      leave:'',
      isShow:false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.autofocus.querySelector('input').focus();
    })
  },
  methods: {
    onSearch(val) {
      this.productList=[]
      let data={
        param:this.value,
        createCompany: 'ZFKJ'
      }
       this.$fetchGet(URL.findplist.url, data).then(res => {
        this.productList = res.data;
        if(res.data.length>0){
          this.leave = res.data[0].name
        }
        if(this.productList.length<=0){
          this.isShow=true
        }
      })
    },
    checkData(ctim) {
      var authFlag = localStorage.getItem('authFlag') || null
      var buyFlag = localStorage.getItem('buyFlag') || null
      let isLogin = localStorage.getItem("isLogin")
      if (authFlag == '0' || authFlag == null || authFlag ==undefined || authFlag =='undefined') {
        // Toast('未实名认证')
        Dialog.alert({
          message: '请前往，我的->个人中心->其他服务，下进行实名认证',
        }).then(() => {
          // on close
        });
      } else if (isLogin != '1') {
        this.$router.push('/login')
      } else {
        console.log(ctim);
        setLocal('img', ctim.img)
        setLocal('Qimg', ctim.qrCode)
        setLocal('Simg', ctim.consultCode)
        setLocal('productId', ctim.id)
        this.$router.push({ path: '/showBusiness', query: { id: ctim.id } })
      }

    },
    onCancel() {
      Toast('取消');
    },
    chooseLi2(item, i) {
      this.isLinkBot = i
      this.leave = item.name
    },
  },
};
</script>

<style lang="less" scoped>
.search-div {
  /deep/ .van-search {
    border-bottom: 1px solid #f7f8fa;
    .van-search__content {
      background-color: transparent;
    }
  }
}
.info-list-bottom {
  width: 355px;
  margin: auto;
  .hint-div{
    margin-top: 20px;
    text-align: center;
    font-size: 12px;
    color: #999;
  }
}
.bank-list {
  width: 355px;
  margin-top: 15.5px;
  padding: 10.5px 0 9.5px 0;
  background: #ffffff;
  border-radius: 10px;
  .list-com {
    width: 335px;
    margin: auto;
  }
  .bank-top,
  .bank-top-left {
    height: 65px;
    display: flex;
  }
  .bank-left-img {
    width: 128px;
    height: 65px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .bank-top {
    justify-content: space-between;
    align-items: center;
  }
  .bank-bottom {
    height: 56.5px;
    margin-top: 12px;
    padding: 3.5px 0;
    line-height: 1.58;
    overflow: hidden;
    background: #f9f9f9;
    p {
      height: 14px;
      padding-left: 17.5px;
      font-size: 10px;
    }
  }
}
.product-list-summary {
  margin-left: 18px;
  font-size: 10.5px;
  font-weight: Regular;
}
.product-list-title {
  margin: 12px 0 8px 18px;
  font-size: 14px;
  font-weight: Bold;
}
.product-safe {
  height: 135px;
  padding: 0;
  align-items: center;
  display: flex;
  .product-safe-left {
    width: 128px;
    height: 110px;
    margin-left: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .product-safe-right {
    // border: 1px solid;
    width: 195.5px;
    height: 110px;
    margin-left: 11.5px;
    position: relative;
    .safe-right-but {
      position: absolute;
      bottom: 0;
      right: 0;
    }
    .safe-right-height {
      height: 48px;
      overflow: hidden;
    }
    .product-list-summary {
      margin-left: 0;
      height: 14px;
    }
    .product-list-title {
      margin: 10px 0 5px 6.5px;
    }
  }
}
.info-dataList {
  width: 335px;
  margin: 25px auto 0 auto;
  display: flex;
  justify-content: space-between;
  border-bottom: 0.5px solid #ededed;
  font-size: 14px;
  font-weight: bold;
  .svg-icon {
    width: 13.5px;
    height: 2px;
    display: block;
    margin-left: 5.5px;
    margin: 5.5px auto 0;
  }
  .li-style2 {
    // width: 24.5px;
    font-size: 12px;
    font-family: PingFang SC;
    color: #333333;
    font-weight: lighter;
  }
  .li-check-style2 {
    font-weight: Regular;
    color: #fc6e09;
  }
}
</style>